export default __webpack_public_path__ + "static/media/Icon-Settings.8f795fa1.svg";